spec_version: "1.1"
id: mw-pareja
slug: mw-pareja
tipo_curso: monografico-gratis
nombre: "Finanzas en pareja"
nombre_corto: "En pareja"
descripcion_corta: "Cómo hablar de dinero sin conflicto, organizar cuentas conjuntas y planificar objetivos financieros compartidos."
idioma: es-ES
duracion_total_min: 120
audiencia: "Parejas que quieren organizar sus finanzas juntas"
editor: "MentorWallet"
version_curso: "0.1.0"
fecha_publicacion: "2026-07-01"
categorias:
  - finanzas-personales
  - familia
modalidad_predominante: mixto
modo_navegacion: "libre"
modulos:
  - 01-hablar-de-dinero
  - 02-cuentas-y-presupuesto
  - 03-objetivos-compartidos
  - 04-proteccion-legal
